import React from 'react'

import * as THREE from 'three'
import { Suspense, useRef, useState } from 'react'
import { Canvas, useFrame, useThree } from '@react-three/fiber'
import { Preload, ScrollControls, Scroll, useScroll, Image as ImageImpl } from '@react-three/drei'
import img1 from './img/img1.jpg'
import img3 from './img/img3.jpeg'
import img6 from './img/img6.jpg'
import img7 from './img/img7.jpg'
import img8 from './img/img8.jpg'
import trip2 from './img/trip2.jpg'
import trip4 from './img/trip4.jpg'
import './bio.css'
function Image({ c = new THREE.Color(), ...props }) {
  const ref = useRef()
  const [hovered, hover] = useState(false)
  useFrame(() => {
    ref.current.material.color.lerp(c.set(hovered ? 'white' : '#ccc'), hovered ? 0.4 : 0.05)
  })
  return <ImageImpl ref={ref} onPointerOver={() => hover(true)} onPointerOut={() => hover(false)} {...props} />
}

function Images() {
  const { width, height } = useThree((state) => state.viewport)
  const data = useScroll()
  const group = useRef()
  useFrame(() => {
    group.current.children[0].material.zoom = 1 + data.range(0, 1 / 3) / 3
    group.current.children[1].material.zoom = 1 + data.range(0, 1 / 3) / 3
    group.current.children[2].material.zoom = 1 + data.range(1.15 / 3, 1 / 3) / 3
    group.current.children[3].material.zoom = 1 + data.range(1.15 / 3, 1 / 3) / 2
    group.current.children[4].material.zoom = 1 + data.range(1.25 / 3, 1 / 3) / 1
    group.current.children[5].material.zoom = 1 + data.range(1.8 / 3, 1 / 3) / 3
    group.current.children[5].material.grayscale = 1 - data.range(1.6 / 3, 1 / 3)
    group.current.children[6].material.zoom = 1 + (1 - data.range(2 / 3, 1 / 3)) / 3
  })
  return (
    <group ref={group}>
      <Image position={[-2, 0, 0]} scale={[4, height, 1]} url={img1} />
    
      <Image position={[2, 0, 1]} scale={3} url={img6} />
      <Image position={[-2.3, -height, 2]} scale={[1, 3, 1]} url={trip2} />
      <Image position={[-0.6, -height, 3]} scale={[1, 2, 1]} url={img8} />
  
      <Image position={[0.75, -height, 3.5]} scale={1.5} url={trip4} />
      <Image position={[0, -height * 1.5, 2.5]} scale={[1.5, 3, 1]} url={img3} />
      <Image position={[0, -height * 2 - height / 4, 0]} scale={[width, height / 2, 1]} url={img7} />
    </group>
  )
}

export default function Bio() {
  return (
  <div className='van2'>
    <Canvas  gl={{ antialias: false }} dpr={[1, 1.5]}>
      <Suspense fallback={null}>
        <ScrollControls damping={0.5} pages={3}>
          <Scroll>
            <Images />
          </Scroll>
          <Scroll html>
            <h1 style={{ position: 'absolute', top: '60vh', left: '0.5em', fontSize: '130px', lineHeight: '130px' }}>Hi</h1>
            <h1 style={{ position: 'absolute', top: '120vh', left: '60vw', fontSize: '130px', lineHeight: '130px' }}>I am Abib</h1>
            <h1 style={{ position: 'absolute', top: '210.5vh', left: '0.5vw', fontSize: '40vw', fontSize: '100px', lineHeight: '100px' }}>
              Full Web Stack Developer
            </h1>
          </Scroll>
        </ScrollControls>
        <Preload />
      </Suspense>
    </Canvas>
    </div>
  )
}
